module.exports = __webpack_public_path__ + "images/sales_contact_suggestion/appeal_background@2x_1e4b7ec1206d13f78c053117f34fa231.png";